export default "__VITE_ASSET__Dv9aiJup__"